import { defineComponent as e, openBlock as t, createBlock as o, unref as r, normalizeProps as n, guardReactiveProps as c } from "vue";
import l from "./ghl-ui.es203.js";
const p = e({
  name: "UIDataTable"
}), s = e({
  ...p,
  setup(_) {
    return (a, m) => (t(), o(r(l), n(c(a.$attrs)), null, 16));
  }
}), i = s;
export {
  i as default
};
